import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError } from 'rxjs/operators';

import * as fromStore from '../store';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LandingPagesGuard {
  private store = inject<Store<fromStore.LandingState>>(Store);

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getLandingPagesLoaded).pipe(
      tap(loaded => {
        console.log(loaded)
        if (!loaded) {
          this.store.dispatch(fromStore.LoadLandingPages());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
